class EstimatedDelivery extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			destinationRange: ".preoder-date",
			productForm: 'form[data-product-form].product-form',
			preoderDate: '.estimated-delivery__destinations input.preoder-date--world'
		};

		this.months = [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec",
		];
		this.elements = {
			preoderDelivery: this.querySelector(this.selectors.preoderDate).dataset.preoderDelivery
		}

		this.init();
	}

	init(){

		this.getEstimations();
	}

	getEstimations() {
		let today = new Date();

		let deliveryDate;

		this
			.querySelectorAll(this.selectors.destinationRange)
			.forEach((el) => {

				const preoderDeliveryDate = this.calculateDeliveryDate(
					today,
					parseInt(this.elements.preoderDelivery)
				);

				el.textContent = `${this.formatDate(
					preoderDeliveryDate
				)}`;
		
				deliveryDate = el.textContent
			});

			this.addProductProprety(deliveryDate);
	}

	addProductProprety(deliveryText){
		const productForm = document.querySelector(this.selectors.productForm);

		productForm.querySelector("input[name='properties[Estimated delivery]']")
			? productForm.querySelector("input[name='properties[Estimated delivery]']").remove()
			: '';

		if(deliveryText){
			const inputText = document.createElement('input');
			inputText.type = 'hidden';
			inputText.name = 'properties[Estimated delivery]';
			inputText.value = deliveryText;
			productForm.appendChild(inputText);
			productForm.setAttribute('data-product-additional-property-estimated-delivery', deliveryText);
		} else {
			productForm.removeAttribute('data-product-additional-property-estimated-delivery', '');
		}
		
	}

	calculateDeliveryDate(today, shippingDays) {
		const outOfHours = today.getHours() > 16 ? 1 : 0;
		const totalDaysToAdd = shippingDays + outOfHours;

		const deliveryDate = new Date(
			today.getTime() + totalDaysToAdd * 24 * 60 * 60 * 1000
		);

		const deliveryDateOusideWeekends = this.calculateWeekends(deliveryDate);

		return deliveryDateOusideWeekends;
	}

	calculateWeekends(today) {
		let cutoutDays = 0;

		switch (today.getDay()) {
			case 6: // Saturday
				cutoutDays += 2;
				break;
			case 0: // Sunday
				cutoutDays += 1;
			default:
				break;
		}

		return new Date(today.setDate(today.getDate() + cutoutDays));
	}

	formatDate(date) {
		return `${date.getDate()} ${this.months[date.getMonth()]}`;
	}
}

customElements.define("estimated-delivery-preoder", EstimatedDelivery);
